/**
* MasterEventIncident defines model for in game incident object information
*
* @typedef MasterEventIncident
* @type {Object}
* @property {incidentID} IncidentID identifier of the incident
* @property {masterEventID} MasterEventID identifier of the master event where the incident accured
* @property {incitentTimeMs} IncidentTimeInMs from the start of the game
* @property {incidentTypeID} IncidentTypeId for the type of the incident
* @property {incidentStatusID} IncidentStatusID of the accured incident
*/

export class MasterEventIncident {

    incidentID: number;
    masterEventID: number;
    incitentTimeMs: number;
    incidentTypeID: number;
    incidentStatusID: number;

    constructor(source: MasterEventIncident) {
        this.incidentID = source.incidentID;
        this.masterEventID = source.masterEventID;
        this.incitentTimeMs = source.incitentTimeMs;
        this.incidentTypeID = source.incidentTypeID;
        this.incidentStatusID = source.incidentStatusID;
    }
}